

<div class="w-full gap-6" 
[ngClass]="accommodation() != 'ecolodge' ? 'flex flex-col items-stretch ' : 'grid lg:grid-cols-4 grid-cols-1'">
    <ng-container *ngFor="let _ of [].constructor(count)">
    
        <div class="flex items-stretch  w-full  border border-solid bg-white overflow-hidden rounded-lg min-h-[240px]"
         [ngClass]="accommodation() != 'ecolodge' ? 'flex-col md:flex-row' : 'flex-col'">
            <div class="dark-overlay h-auto   before:!rounded-none"
             [ngClass]="accommodation() != 'ecolodge' ? 'w-full md:w-[250px] min-h-[230px]' : 'w-full min-h-[150px]'"></div>
    
    
            <div class="flex flex-grow p-4 justify-between" 
            [ngClass]="accommodation() != 'ecolodge' ? 'flex-col md:flex-row' : 'flex-col'">
                <div class="flex flex-col gap-3 bordered-section pb-4 md:pl-4 md:pb-0 flex-grow">
                    <div class="flex items-center gap-2 mb-1" *ngIf="accommodation() != 'ecolodge'">
                        <iho-skeleton height="1.25rem" width="4.5rem" />
                        <iho-skeleton height="1.25rem" width="7rem" />
                    </div>
    
                    <div class="flex items-center gap-2 mb-5">
                        <iho-skeleton type="circle" height="2.5rem" width="2.5rem" />
                        <iho-skeleton height="1.25rem" width="12rem" />
                    </div>
    
                    <div class="flex items-center gap-2">
                        <iho-skeleton type="circle" height="1.25rem" width="1.25rem" />
                        <iho-skeleton height="1rem" width="4.5rem" />
                    </div>
    
                    <div class="flex items-center gap-2">
                        <iho-skeleton type="circle" height="1.25rem" width="1.25rem" />
                        <iho-skeleton height="1rem" width="8rem" />
                    </div>
    
                    <div class="flex items-center gap-2">
                        <iho-skeleton height="1rem" width="4.5rem" />
                        <iho-skeleton height="1rem" width="6rem" />
                    </div>

                    <iho-skeleton height="2rem" width="17rem" *ngIf="accommodation() != 'ecolodge'"/>
                </div>
    
                <div class="flex flex-col gap-2 h-full pt-4 md:pt-0 md:pr-4 justify-end items-end md:max-w-[250px]" 
                [ngClass]="accommodation() != 'ecolodge' ? '' : 'mt-3'">
                    <iho-skeleton height="1rem" width="6rem" *ngIf="accommodation() != 'ecolodge'"  />
                    <iho-skeleton height="1.5rem" width="8rem" />
                    <iho-skeleton height="2.5rem" width="12.5rem" class="hidden md:block" />
                </div>
            </div>
    
        </div>
    
    </ng-container>
</div>